import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { ModalController, IonInput } from '@ionic/angular';

import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';

import { Provider } from '../../../core/models/provider.model';
import { Event } from '../../../core/models/event.model';
import { Booking } from '../../../core/models/booking.model';

import { BookingAttendee } from '../../../core/models/booking-attendee.model';

import { User } from '../../../core/models/user.model';

import { parse, format, AsYouType } from 'libphonenumber-js';
import { PhoneUtilsService } from 'angular-phone-utils-lib';

import { ValidatorFn } from '@angular/forms';
import { IonIntlTelInputModel } from 'ion-intl-tel-input';
import { IonIntlTelInputValidators } from 'ion-intl-tel-input';

// Function to make any validator optional
function optionalValidator(validatorFn: ValidatorFn): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} | null => {
    if (control.value == null || control.value === '') {
      return null; // consider empty values as valid
    }
    return validatorFn(control); // otherwise, use the original validator
  };
}

@Component({
  selector: 'app-attendee-form-modal',
  templateUrl: './attendee-form-modal.component.html',
  styleUrls: ['./attendee-form-modal.component.scss'],
})
export class AttendeeFormModalComponent implements OnInit {

  @Input() bookingAttendee?: BookingAttendee;
  @Input() event: Event;
  @Input() eventBooking?: Booking;
  @Input() provider: Provider;
  @Input() mode: 'add'|'edit';

  attendeeForm: FormGroup;

  initialFormValue: any;

  loading = false;

  @ViewChild('emailInput', { static: false }) emailInput!: IonInput;

  constructor(
    private modalCtrl: ModalController,
    private fb: FormBuilder,
    private phoneUtils: PhoneUtilsService
  ) { }

  addModeInit() {
    this.bookingAttendee = new BookingAttendee();
  }

  editModeInit() {

  }

  private getPricePilotNumberFormat = function (numberObj) {

    if (numberObj && numberObj.dialCode && numberObj.nationalNumber) {
      return numberObj.dialCode + ' ' + numberObj.nationalNumber.substring(1).replace(/\D+/g, '');
    } 

    return '';
  }



  ngOnInit() {

    /*if ( !this.provider ) {
      throw new Error('Provider must be provided!');
    }*/

    if ( !this.event ) {
      throw new Error('Event must be provided!');
    }

    if ( !this.eventBooking ) {
      throw new Error('Booking must be provided!');
    }

    if ( this.isMode('add') ) { //ADD NEW

      this.addModeInit();
        
    } else if ( this.isMode('edit') )  {

      if ( !this.bookingAttendee ) {
        throw new Error('Booking attendee must be provided!');
      }

      this.editModeInit();

    } else {
      throw new Error('Mode is not add or edit!');
    }

    let phone: IonIntlTelInputModel = null;


    if ( this.bookingAttendee.phone ) {
      phone = {
        dialCode: '+386',
        internationalNumber: this.phoneUtils.getInternational( this.bookingAttendee.phone, 'SI'),
        isoCode: 'si',
        nationalNumber: this.phoneUtils.getNational( this.bookingAttendee.phone, 'SI'),
      }
    }

    this.attendeeForm = this.fb.group({
      name: [ this.bookingAttendee.name ?? null, [Validators.minLength(2)]],
      surname: [ this.bookingAttendee.surname ?? null, [Validators.minLength(2)]],
      phone: [ phone ?? null, [optionalValidator(IonIntlTelInputValidators.phone)]],
      email: [ this.bookingAttendee.email ?? null, [Validators.email]],
      street: [ this.bookingAttendee.street ?? null ],
      zipCode: [ this.bookingAttendee.zipCode ?? null, [Validators.pattern('^[0-9]{4,6}$')]],
      city: [ this.bookingAttendee.city ?? null ],
      country: [ this.bookingAttendee.country ?? null ],
      dateOfBirth: [ this.bookingAttendee.dateOfBirth ?? null ],
      personalIdentNumber: [ this.bookingAttendee.personalIdentNumber ?? null , [Validators.pattern('^[0-9]{13}$')]], // EMŠO must be 13 digits
      passportNumber: [ this.bookingAttendee.passportNumber ?? null ],
      notifications: [ this.bookingAttendee.notifications ?? false ]
    }, { validators: this.atLeastOneFieldRequiredValidator });

     // Store initial values after loading data
    this.initialFormValue = this.normalizeFormValue(this.attendeeForm.value);


  }

  // Custom Validator: Ensures at least one field is filled
  atLeastOneFieldRequiredValidator(formGroup: AbstractControl) {
    const fields = ['name', 'surname', 'email', 'street', 'zipCode', 'city', 'country', 'dateOfBirth', 'personalIdentNumber', 'passportNumber'];
    const hasValue = fields.some(field => formGroup.get(field)?.value?.trim());

    return hasValue ? null : { atLeastOneRequired: true }; // Return error if all fields are empty
  }

  onCancel() {
    this.modalCtrl.dismiss( {}, 'closed' );
  }

  isMode( mode ) {
    return (this.mode === mode);
  }


  mapFormToModel( formValue ): BookingAttendee {

    this.bookingAttendee.name = this.attendeeForm.value.name;
    this.bookingAttendee.surname = this.attendeeForm.value.surname;
    this.bookingAttendee.phone = this.getPricePilotNumberFormat(this.attendeeForm.value.phone);
    this.bookingAttendee.email = this.attendeeForm.value.email;
    this.bookingAttendee.dateOfBirth = this.attendeeForm.value.dateOfBirth;
    console.log(this.attendeeForm.value.dateOfBirth);


    this.bookingAttendee.notifications = this.attendeeForm.value.notifications;
    this.bookingAttendee.street = this.attendeeForm.value.street;
    this.bookingAttendee.zipCode = this.attendeeForm.value.zipCode;
    this.bookingAttendee.city = this.attendeeForm.value.city;
    this.bookingAttendee.country = this.attendeeForm.value.country;
    this.bookingAttendee.personalIdentNumber = this.attendeeForm.value.personalIdentNumber;
    this.bookingAttendee.passportNumber = this.attendeeForm.value.passportNumber;

    return this.bookingAttendee;

  }

  onSubmit() {

    if (this.attendeeForm.valid) {

      //convert form to attendee's object

      console.log('Form submitted:', this.attendeeForm.value);

      if ( this.attendeeForm.valid ) {
        this.modalCtrl.dismiss({
          bookingAttendee: this.mapFormToModel( this.attendeeForm.value ),
        }, ( this.isMode('add') ? 'attendeeAdded': 'attendeeEdited' ) );
      }

      // Handle form submission (e.g., send data to API)
    } else {
      console.log('Form invalid');
    }
  }

  // Normalize the form values for proper comparison
  normalizeFormValue(formValue: any): any {
    return Object.keys(formValue).reduce((acc, key) => {
      acc[key] = formValue[key] ?? ''; // Convert null to ''
      return acc;
    }, {});
  }

  isFormUnchanged(): boolean {
    const currentFormValue = this.normalizeFormValue(this.attendeeForm.value);
    return JSON.stringify(currentFormValue) === JSON.stringify(this.initialFormValue);
  }

  handleEnterKey(event: KeyboardEvent) {
    if (this.attendeeForm.valid && !(this.mode === 'edit' && this.isFormUnchanged())) {
      this.onSubmit(); // Submit when Enter is pressed and form is valid
      event.preventDefault(); // Prevent accidental form resubmission
    }
  }

  onPhoneKeydown(event: KeyboardEvent) {
    if (event.key === 'Tab') {
      console.log('Tab pressed in phone input');
      
      // Small delay to allow tab to complete if not shift+tab
      setTimeout(() => {
        this.emailInput.setFocus();
      }, 0);
      
    }
  }

  get formControls() {
    return this.attendeeForm.controls;
  }

  onDateChange(event: any) {
    const selectedDate = event.detail.value;
    this.attendeeForm.controls.dateOfBirth.setValue(selectedDate);
  }

}
